import d from "./_root.js";
var p = typeof exports == "object" && exports && !exports.nodeType && exports, t = p && typeof module == "object" && module && !module.nodeType && module, s = t && t.exports === p, n = s ? d.Buffer : void 0, l = n ? n.allocUnsafe : void 0;
function a(e, u) {
  if (u)
    return e.slice();
  var o = e.length, r = l ? l(o) : new e.constructor(o);
  return e.copy(r), r;
}
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_cloneBuffer.js
// module id = 870
// module chunks = 41